module.exports = __webpack_public_path__ + "img/img1.98c3419a.jpeg";